export { default } from './IsBrowser';



// WEBPACK FOOTER //
// ./src/universal/components/IsBrowser/index.js